<template>
  <header class="lbs-viewer-popup-header">
    <div class="title">
      {{ showName }}
    </div>
    <div class="close"
         @click="callPopupHeader">
      X
    </div>
  </header>
</template>

<script>
  export default {
    name: 'PopupHeader',
    props: {
      title: {
        type: String,
        required: true
      }
    },
    computed: {
      showName () {
        const patientName = this.title.split(/[|-]/);
        return patientName[0];
      }
    },
    methods: {
      callPopupHeader () {
        this.$events.trigger('us:resize-viewer:popup-header');
      }
    }
  };
</script>

<style scoped lang="scss">
  .lbs-viewer-popup-header {
    position: relative; // anchor for absolutely-positioned close button

    .title {
      font-weight: bold;
      padding: 3px 10px;
    }

    .close {
      padding: 3px 5px;
      cursor: pointer;

      position: absolute; // drag the button to the right side
      right: 0;
      top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/viewer/components/PopupHeader.vue